import React from "react";
import BenefitImg from "./img/benefits-bg.jpg";
import GetTargeted from "./img/get-targeted-audience.png";
import MentorExp from "./img/mentor-experience.png";
import SloveChlnge from "./img/solve-chalanges.png";
import SpecificExprt from "./img/specific-expertise.png";
import "../../style.scss";
import "./style.scss";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from 'react-i18next';
export default function BenefitMentor(props) {
  const { t } = useTranslation();
  const keyData = props.data || [];
  return (
    <div className="BgBenefitMentor">
      <section
        style={{
          // backgroundColor: "#e6e7e8",
          background: BenefitImg,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div class="w-100 pt-50 pb-50 position-relative text-center">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0 homepageFirstHeader">
                {t('The_Benefits_of_Mentorship')}
                  {/* The Benefits of Mentorship */}
                  </h2>
              </div>
              <div class="col-md-12 col-sm-12 col-lg-12 wow fadeInDown">
                <div class="get-a-mentor ">
                  <p className="homepageFirstDescription" >
                  {t('Sustain_and_grow_your_business')}
{/*                   
                    Sustain and grow your business fundamentals and gain
                    lifelong connects by tapping into our mentorship program.{" "} */}
                  </p>
                </div>
              </div>
            </div>

            <div class="row" style={{ paddingTop: "30px" }}>
              {keyData.map((data, i) => {
                return (
                  <div class="col-md-6 col-sm-6 col-lg-6 wow " key={i}>
                    <div class="row">
                      <div
                        class="col-md-4 col-sm-4 col-lg-4 wow slideInLeft benefitsMentor"
                        style={{
                        
                        }}
                      >
                        <img
                          //   src={GetTargeted}
                          src={data.Image}
                        />
                      </div>
                      <div class="col-md-8 col-sm-8 col-lg-8 wow slideInLeft">
                        <div class="info mentorben">
                          <h4 style={{ fontSize: "20px"  }} className="homepageFirstDescription">{data.Heading}</h4>
                          <div className="homepageFirstDescription" >
                          {HTMLReactParser(data.Text)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
